import * as React from 'react';

import * as styles from './asideItem.css';

export const AsideItem = (props: React.PropsWithChildren<{}>) => {
  return <div className={styles['item']}>{props.children}</div>;
};
